import { render } from "./StockRankingTable.vue?vue&type=template&id=1faa1200"
import script from "./StockRankingTable.vue?vue&type=script&lang=js"
export * from "./StockRankingTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__